module.exports = __webpack_public_path__ + "static/media/process.bcf44f8c.png";